// Central runtime configuration accessor.
// Prefers window.__RUNTIME_CONFIG__ (editable post-build via public/config.js,
// useful for static/FTP hosting) and falls back to build-time env vars
// (used during local development via `yarn start`).
const runtime = typeof window !== "undefined" ? window.__RUNTIME_CONFIG__ : null;

export const BACKEND_URL = (runtime && runtime.BACKEND_URL) || process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const PAYPAL_CLIENT_ID = (runtime && runtime.PAYPAL_CLIENT_ID) || process.env.REACT_APP_PAYPAL_CLIENT_ID;
